import React, { useEffect, useState } from 'react';
import CSSLoader from '../../../shared/cssLoader';
import styles from './viewOneWayInterview.module.scss';
import { Col, Row, Form, Card, Button, Accordion, Tab, Tabs } from 'react-bootstrap';
import { getOneWayInterviewTask, submitOneWayInterviewReview } from '../../../../services/util/oneWayInterview';
import CustomNavbar from '../../customNavbar';
import { useParams, useNavigate } from 'react-router-dom';
import { Helmet } from "react-helmet";
import Avatar from 'react-avatar';
import StarRating from '../../../shared/rate';
import { Formik } from 'formik';
import * as yup from 'yup';
import { CustomButton } from '../../../shared/customButton';
import { CustomConfirmationModal } from '../../../shared/customConfirmationModal';
import AddCandiateNoteModal from '../../common/addCandidateSpecialNoteModal';
import { CustomConfirmationBox } from '../../../shared/customConfirmationBox';
import { failCandidateManually } from '../../../../services/util/hiringpipeline/candidates';


const ViewOneWayInterview = (props) => {
    let [isLoading, setLoading] = useState(false);
    let { id } = useParams();
    let [initialData, setInitialData] = useState(null);
    const [reviewCriteriaRating, setReviewCriteriaRating] = useState([]);
    const [calOverallMark, setCalOverallMark] = useState(null);
    let [state, setState] = useState({
        comments: []
    });
    let [emptyCommentsError, setEmptyCommentsError] = useState(false);
    let [emptyMarksError, setEmptyMarksError] = useState(false);
    let [questionData, setQuestionData] = useState([]);
    let [assignedQuestionData, setAssignedQuestionData] = useState(null);
    let [outOfRangeOverallMarksError, setOutOfRangeOverallMarksError] = useState(false);
    let [marks, setMarks] = useState(-1);
    const [isModalOpen, setModalOpen] = useState(false);
    const [isSubmit, setSubmit] = useState(false);
    let [emptyOverallMarksError, setEmptyOverallMarksError] = useState(false);
    let [specialNoteModalOpen, setSpecialNoteModalOpen] = useState(false);
    let history = useNavigate();
    let [isRejectedWithoutMarksModalOpen, setIsRejectedWithoutMarksModalOpen] = useState(false);
    let [actionsSubmitLoading, setActionsSubmitLoading] = useState(false);

    const breadcrumb = [
        {
            pathaddress: '/app/company/one-way-interviews',
            pathname: 'One Way Interviews',
            isActive: false,
            key: 1 + 'one-way-interview'
        },
        {
            pathaddress: '',
            pathname: initialData?.candidate_first_name + ' ' + initialData?.candidate_last_name+ "'s answers",
            isActive: true,
            key: 1 + initialData?.candidate_first_name + ' ' + initialData?.candidate_last_name,
        }
    ]

    const breacrumbText = 'Here you can see one-way interview answers submitted by the candidate. Review the video recorded answers and submit your ratings.'

    const schema = yup.object({
        comments: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').required('Required'),
    });

    async function loadInitialData() {
        setLoading(true);
        //getting query parameter value
        if (id) {
            let respond = await getOneWayInterviewTask(id);
            if (respond.success === true) {
                setInitialData(respond.data);
                setQuestionData(respond.data.custom_questions);
                InitialQuestionAssign(respond.data.custom_questions[0]);
                setLoading(false);
            } else {
                props.history(`/company/one-way-interviews`);
                setLoading(false);
            }
        }
    }

    const handleRatingChange = (id, rating, label) => {
        let data = {
            rate: rating,
            label: label,
        }
        setReviewCriteriaObj(data);
    };

    const setReviewCriteriaObj = (data) => {
        const reviewCriteriaList = [...reviewCriteriaRating];
        if (reviewCriteriaRating.length === 0) {
            setReviewCriteriaRating(current => ([...current, data]));
        }
        else {
            let reviewRating = reviewCriteriaList.find(reviewCriteriaRating => reviewCriteriaRating.label === data.label);
            if (reviewRating) {
                reviewRating.rate = data.rate === null ? 0 : data.rate;
                setReviewCriteriaRating(reviewCriteriaList);
            }
            else {
                setReviewCriteriaRating(current => ([...current, data]));
            }
        }
    }

    //on adding comments function
    const onSubmit = async (values, { resetForm }) => {
        setEmptyCommentsError(false)
        addComment(values.comments);
        resetForm({ comments: '' });
    }

    //add comment function
    function addComment(item) {
        setState(state => ({
            comments: [...state.comments, item]
        }));
    }
    //remove comment function
    function removeComment(item) {
        let array = [state.comments];
        if (item !== -1) {
            array[0].splice(item, 1);
            setState({
                comments: array[0]
            })
        }
    }

    const [currentQuestion, setCurrentQuestion] = useState(0); // Current page number

    const handlePreviousClick = () => {
        setLoading(true);
        if (currentQuestion > 0) {
            let quesionNum = currentQuestion - 1;
            setCurrentQuestion(currentQuestion - 1);
            AssignedQuestion(quesionNum);
        }
        setLoading(false);
    };

    const handleNextClick = () => {
        setLoading(true);
        const totalQuestions = questionData.length;
        if (currentQuestion < totalQuestions) {
            let quesionNum = currentQuestion + 1;
            setCurrentQuestion(currentQuestion + 1);
            AssignedQuestion(quesionNum);
        }
        setLoading(false);
    };
    const totalQuestions = questionData.length;

    const AssignedQuestion = (value) => {

        let data = questionData[value]
        setAssignedQuestionData(data);

    }

    const InitialQuestionAssign = (value) => {
        setAssignedQuestionData(value);
    }

    function checkValidationAndOpenModal() {
        //using "marks" for older pipes and "overallmarks" for more recent pipelines
        //check whether comments and marks(calOverallMark or marks) null
        if (state.comments.length >= 0 && ((calOverallMark > -1 && calOverallMark < 101 && calOverallMark != "" && calOverallMark !== null) || marks !== -1)) {
            setOutOfRangeOverallMarksError(false);
            setModalOpen(true);
        }
        else {
            if (marks === -1) {
                setEmptyMarksError(true)
            }
            if (calOverallMark < 0 || calOverallMark > 100 || calOverallMark === null || calOverallMark == "") {
                setOutOfRangeOverallMarksError(true)
            }
        }
    }

    //submit values function
    async function submitValues() {
        if (state.comments.length >= 0 && (calOverallMark !== null || marks !== -1)) {
            const reviewCriteriaData = [];
            for (let key in initialData?.review_criteria) {
                for (let keys in reviewCriteriaRating) {
                    if (initialData?.review_criteria[key].label === reviewCriteriaRating[keys].label) {
                        if (reviewCriteriaRating[keys].rate !== 0) {
                            const newOverallRating = {
                                _id: initialData?.review_criteria[key]._id,
                                label: initialData?.review_criteria[key].label,
                                rate: reviewCriteriaRating[keys].rate,
                            }
                            reviewCriteriaData.push(newOverallRating)
                        }
                    }
                }
            }
            setSubmit(true)
            //convert marks to 100% and assign to score
            let score = calOverallMark !== null ? calOverallMark : (marks * 10).toFixed(1);
            let respond = await submitOneWayInterviewReview(id, score, state.comments, reviewCriteriaData ? reviewCriteriaData : null)

            if (respond.success === true) {
                props.GetTaskValues();
                history(`/company/one-way-interviews/group?step_id=${initialData?.step_id}`);
                setSubmit(false);
            } else {
                setSubmit(false);
            }
        } else {
            if (marks === -1) {
                setEmptyMarksError(true)
            }
            if (calOverallMark === null) {
                setEmptyOverallMarksError(true);
            }
        }
    }

    //open and close note modal
    const openSpecialNoteModal = () => {
        setSpecialNoteModalOpen(true);
    }

    const closeSpecialNoteModal = () => {
        setSpecialNoteModalOpen(false);
    }

    useEffect(() => {
        loadInitialData();
    }, [])

    useEffect(() => {
        calculateMarks();
    }, [reviewCriteriaRating])

    const calculateMarks = () => {
        var results = 0;
        var addition = 0;
        var divider = 0;
        for (let key in reviewCriteriaRating) {
            if (reviewCriteriaRating[key].rate !== 0) {
                addition += reviewCriteriaRating[key].rate;
                divider += 1;
            }
        }
        if (addition !== 0) {
            results = (addition / (divider * 5)) * 100;
        }
        setCalOverallMark(results === 0 ? null : results.toFixed(1))
    };

    function viewCandidate(val) {
        let path = `/app/company/candidate`;
        let search = 'cid=' + val;

        const url = `${path}?${search}`;
        window.open(url);
    }
    const manuallyFailCandidateWithoutMarks = async (value) => {
        setActionsSubmitLoading(true);
        let candidate_id =[];
        candidate_id.push(initialData.candidate_id) 
        let respond = await failCandidateManually(candidate_id, initialData.pipeline_step, value.reason);
        if (respond.success === true) {
            setActionsSubmitLoading(false);
            setIsRejectedWithoutMarksModalOpen(false);
            props.GetTaskValues();
            history(`/company/one-way-interviews`);
        } else {
            setActionsSubmitLoading(false);
            setIsRejectedWithoutMarksModalOpen(false);
        }
    };

    return (
        <div>
            <Helmet>
                <title>One-Way Interview | HireTrace</title>
            </Helmet>
            {isLoading === true ?
                (<div className={styles.loadingDiv}>
                    <Col sm={{ span: 4, offset: 4 }}>
                        <CSSLoader />
                    </Col>
                </div>)
                :
                (<div>
                    <CustomConfirmationBox
                        show={isRejectedWithoutMarksModalOpen}
                        cancelIconclick={() => setIsRejectedWithoutMarksModalOpen(false)}
                        onSecondaryBtnClick={() => setIsRejectedWithoutMarksModalOpen(false)}
                        onFormSubmit={manuallyFailCandidateWithoutMarks}
                        isSecondaryBtnDisabled={actionsSubmitLoading === true ? true : false}
                        isPrimaryBtnDisabled={actionsSubmitLoading === true ? true : false}
                        primaryBtnBackSideIcon={actionsSubmitLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                        topic="Are you sure?"
                        message="You are trying to reject selected candidate from the pipeline. Candidate overall status will be failed."
                        secondaryBtnName="backBtn"
                        secondaryBtnType="button"
                        secondaryBtnCssType="defaultBtn"
                        secondaryBtnLabel="Cancel"
                        primaryBtnName="submitBtn"
                        primaryBtnType="submit"
                        primaryBtnCssType="dangerBtn"
                        primaryBtnLabel="Yes, reject candidate"
                        checkboxLabel="I confirm to manually reject selected candidate from the pipeline"
                    />

                    {/* submit result alert confirmation start */}
                    <CustomConfirmationModal
                        show={isModalOpen}
                        confirmationType='success'
                        cancelIconclick={() => setModalOpen(false)}
                        onSecondaryBtnClick={() => setModalOpen(false)}
                        onPrimaryBtnClick={submitValues}
                        isSecondaryBtnDisabled={isSubmit === true ? true : false}
                        isPrimaryBtnDisabled={isSubmit === true ? true : false}
                        primaryBtnBackSideIcon={isSubmit === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                        confirmationTopic="Are you sure?"
                        confirmationMessage="Your feedback cannot change later."
                        secondaryBtnName="backBtn"
                        secondaryBtnType="button"
                        secondaryBtnCssType="primaryBtn"
                        secondaryBtnLabel="Cancel"
                        primaryBtnName="submitBtn"
                        primaryBtnType="button"
                        primaryBtnCssType="successBtn"
                        primaryBtnLabel="Yes, Submit!"
                    />
                    {/* submit result alert confirmation end */}

                    {/* add note modal open */}
                    {specialNoteModalOpen &&
                        <AddCandiateNoteModal showModal={specialNoteModalOpen} handleClose={() => setSpecialNoteModalOpen(false)} candidateID={initialData.candidate_id} />
                    }
                    {/* add note modal close */}

                    <div className={styles.backgroundFixedComponents}>
                        <CustomNavbar history={props.mainHistory} breadcrumbArray={breadcrumb} breacrumbText= {breacrumbText}/>
                    </div>
                    <Row>
                        <Col>
                            <div className={styles.reviewDetails}>
                                <Row>
                                    <Col md={1} lg={1} xl={1} className={styles.candidatePhoto}>
                                        <Avatar src={initialData?.candidate_photo_url} name={initialData?.candidate_first_name + ' ' + initialData?.candidate_last_name} size="90" round={false} />
                                    </Col>
                                    <Col md={11} lg={11} xl={11} className={styles.candidateDetails}>
                                        <Row>
                                            <Col sm={5}>
                                                <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Name : </span><span className={styles.reviewDetailsValue}>{initialData?.candidate_first_name + ' ' + initialData?.candidate_last_name}</span> <i class="fas fa-external-link-alt ml-1S" id={styles.openInNewtabIcon} onClick={() => viewCandidate(initialData?.candidate_id)}></i> </p>
                                                <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Email : </span><span className={styles.reviewDetailsValue}>{initialData?.candidate_email}</span></p>
                                                <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Mobile : </span><span className={styles.reviewDetailsValue}>{`(${initialData?.candidate_mobile_country_code}) ${initialData?.candidate_mobile_number}`}</span></p>
                                                <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Passing Threshold : </span><span className={styles.reviewDetailsValue}>{initialData?.minimum_pass_score}%</span></p>
                                            </Col>
                                            <Col sm={5}>
                                                <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Pipeline : </span><span className={styles.reviewDetailsValue}>{initialData?.pipeline_name}</span></p>
                                                <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Position : </span><span className={styles.reviewDetailsValue}>{initialData?.hiring_position}</span></p>
                                                <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Stage Name : </span><span className={styles.reviewDetailsValue}>{initialData?.pipeline_stage_name}</span></p>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Review Criteria : </span><span className={styles.reviewDetailsValue}>{initialData?.evaluation_criteria}</span></p>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </div>

                        </Col>
                    </Row>
                    <Row className={styles.cardMainRow}>
                        <Col lg={8} className={styles.videoCardColMain}>
                            <Row className={styles.reviewFirstRow}>
                                <div className={styles.reviewTopicRowHeader}>
                                    <p className={styles.reviewHeaderLeftText}>Question {currentQuestion + 1}</p>
                                    <p className={styles.reviewHeaderRightText}>Answer {currentQuestion + 1} of {totalQuestions}</p>
                                </div>
                                <p className={styles.reviewHeaderSecondText}>{assignedQuestionData?.title}</p>
                                <p className={styles.reviewHeaderThirdText}>{assignedQuestionData?.question}</p>
                                <div className={styles.reviewTopicRowHeaderAns}>
                                    <p className={styles.reviewHeaderLeftText}>Answer</p>
                                </div>
                            </Row>
                            <div className={styles.videoCardMain}>
                                <video src={assignedQuestionData?.answer} type="video/mp4" controls className={styles.videoCardVideo} />
                            </div>
                            <div className={styles.bottomTableDiv}>
                                <div>
                                    {currentQuestion > 0 && (
                                        <button
                                            onClick={handlePreviousClick}
                                            className={styles.paginationPrevButton}
                                        >
                                            Previous
                                        </button>
                                    )}
                                    {(currentQuestion < questionData.length - 1) && (
                                        <button
                                            onClick={handleNextClick}
                                            className={styles.paginationNextButton}
                                        >
                                            Next
                                        </button>
                                    )}
                                </div>

                            </div>
                        </Col>
                        <Col lg={4} className={styles.reviewColMain}>
                            <div className={styles.addNoteDiv}>
                                <p className={styles.noteValue} onClick={() => openSpecialNoteModal()}>Add special note</p>
                            </div>
                            <Row className={styles.reviewSecondRow}>
                                <p className={styles.reviewSecondRowText}>Evaluation Criteria</p>
                                <div>
                                    <div>
                                        {initialData?.review_criteria && initialData?.review_criteria.map((value, i) => (
                                            <div className={styles.reviewDetailsDiv}>
                                                <div className={styles.reviewDetailsSecondDiv}>
                                                    <span className={styles.reviewFeedbackValue }>{value.label}</span>
                                                    <span className={styles.reviewFeedbackStars }><StarRating className="mr-4" disabled={false} id={i} onRatingChange={(reviewCriteriaRating) => { handleRatingChange(i, reviewCriteriaRating, value.label); setOutOfRangeOverallMarksError(false) }} /></span>
                                                </div>
                                            </div>
                                        ))
                                        }
                                        <p className={styles.reviewFeedbackOverallScore}><span className={styles.reviewFeedbackOverallScoreLabel}>Overall Marks : </span><span className={styles.reviewFeedbackOverallScoreLabelValue}>{(calOverallMark && calOverallMark > 0) ? calOverallMark : 0}%</span></p>
                                        {(outOfRangeOverallMarksError === true) &&
                                            <p className={styles.reviewErrorMsg}> You have to give at least one star rating.</p>
                                        }
                                    </div>
                                </div>
                                <div>
                                    <Formik
                                        validationSchema={schema}
                                        onSubmit={(values, resetForm) => onSubmit(values, resetForm)}
                                        initialValues={{}}>

                                        {({
                                            values,
                                            errors,
                                            setFieldValue,
                                            handleChange,
                                            handleSubmit,
                                            submitCount,
                                            resetForm
                                        }) => (
                                            <div>

                                                <Form noValidate onSubmit={handleSubmit}>
                                                    <Form.Group controlId="comments">
                                                        <Form.Label className={styles.reviewCommentsLabel}>Comments</Form.Label>
                                                        <Form.Control as="textarea" name="comments" value={values.comments || ''} onChange={(e) => { setFieldValue('comments', e.target.value); }} rows={3} className={styles.reviewCommentsBox} isInvalid={errors.comments || emptyCommentsError} onFocus={() => setEmptyCommentsError(false)} />
                                                        <p className={styles.reviewErrorMsg}>{errors.comments}</p>
                                                    </Form.Group>
                                                    <div className={styles.reviewCommentsAddBtnBox}>
                                                        <CustomButton
                                                            id="add_comment"
                                                            buttonType="submit"
                                                            label="Add Comment"
                                                            type="secondaryBtn"
                                                            handleClick={handleChange}
                                                            frontIcon={
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                    <path d="M9.99984 4.16663V15.8333M4.1665 9.99996H15.8332" stroke="#2790A6" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                                </svg>
                                                            }

                                                        />
                                                    </div>

                                                    <div className='mb-1 pb-1'>
                                                        {
                                                            state.comments.map((item, i) => (
                                                                <Row className='m-0 p-1'>
                                                                    <Col sm={11} className='m-0 p-0'>
                                                                        <Card className={styles.reviewCommentBox} key={i}>
                                                                            <Card.Body className={styles.reviewCommentBoxBody}>
                                                                                <span className={styles.reviewCommentsInnerBox}>
                                                                                    <span className={styles.reviewCommentValue}>{item}</span>
                                                                                </span>
                                                                            </Card.Body>
                                                                        </Card>
                                                                    </Col>
                                                                    <Col sm={1} className={styles.reviewCommentSecondCol}>
                                                                        <span className={styles.cancelIconDiv} onClick={() => removeComment(i)} key={(props.keyValue) + 1}>
                                                                            <svg className={styles.cancelIcon} width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <g id="trash-01">
                                                                                    <path id="Icon" d="M13.3333 5.49999V4.83332C13.3333 3.8999 13.3333 3.43319 13.1517 3.07667C12.9919 2.76307 12.7369 2.5081 12.4233 2.34831C12.0668 2.16666 11.6001 2.16666 10.6667 2.16666H9.33333C8.39991 2.16666 7.9332 2.16666 7.57668 2.34831C7.26308 2.5081 7.00811 2.76307 6.84832 3.07667C6.66667 3.43319 6.66667 3.8999 6.66667 4.83332V5.49999M8.33333 10.0833V14.25M11.6667 10.0833V14.25M2.5 5.49999H17.5M15.8333 5.49999V14.8333C15.8333 16.2335 15.8333 16.9335 15.5608 17.4683C15.3212 17.9387 14.9387 18.3212 14.4683 18.5608C13.9335 18.8333 13.2335 18.8333 11.8333 18.8333H8.16667C6.76654 18.8333 6.06647 18.8333 5.53169 18.5608C5.06129 18.3212 4.67883 17.9387 4.43915 17.4683C4.16667 16.9335 4.16667 16.2335 4.16667 14.8333V5.49999" stroke="#B42318" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                                                </g>
                                                                            </svg>
                                                                        </span>
                                                                    </Col>
                                                                </Row>
                                                            ))
                                                        }
                                                    </div>
                                                </Form>
                                            </div>
                                        )}
                                    </Formik>
                                </div>
                                <div className='mt-3'>
                                    <CustomButton
                                        buttonType="submit"
                                        type="primaryBtn"
                                        label="Submit Marks and Feedback"
                                        disabled={isSubmit === true ? true : false}
                                        handleClick={checkValidationAndOpenModal}
                                    />
                                </div>
                               
                            </Row>
                        </Col>
                    </Row>
                </div>)
            }
        </div>
    )
}

export default ViewOneWayInterview